module.exports = __webpack_public_path__ + "static/img/xinfeng-nei-no-active.fdb5ae8c.png";